export const isChinaUser = () => {
    return window.location.href.indexOf('garmin.cn') !== -1 || window.chinaMode;
};

export const isCDCUser = () => {
    return (
        window.chinaMode ||
        (window.location.href.indexOf('garmin.cn') !== -1 && window.location.href.indexOf('connectus.garmin.cn') === -1)
    );
};
